import { render, staticRenderFns } from "./UsedTicket.vue?vue&type=template&id=ade8e83e&"
import script from "./UsedTicket.vue?vue&type=script&lang=ts&"
export * from "./UsedTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports